import type { UserRole } from '@/components/onboarding/types';
import type { Language } from '@/i18n/translations';

export const ROLE_LAYERS: Record<UserRole, Partial<Record<Language, string>> & { en: string }> = {
  designer: {
    sv: 'Använd visuell/UX-terminologi: user journey, flöde, affordance, visuell hierarki, empathy. Fokusera på "hur känns det för användaren?". Föreslå 3D-vy och multi-sheet när det förbättrar upplevelsen.',
    en: 'Use visual/UX terminology: user journey, flow, affordance, visual hierarchy, empathy. Focus on "how does it feel for the user?". Suggest 3D view and multi-sheet when it improves the experience.',
  },
  developer: {
    sv: 'Använd teknisk vokabulär: API, endpoints, constraints, skalbarhet, architecture patterns. Fråga implicit "är detta tekniskt genomförbart?" och föreslå implementationstips. Ge gärna JSON-exempel.',
    en: 'Use technical vocabulary: API, endpoints, constraints, scalability, architecture patterns. Implicitly ask "is this technically feasible?" and suggest implementation tips. Provide JSON examples when useful.',
  },
  business: {
    sv: 'Fokusera på affärsvärde, KPI:er, ROI, tid- och kostnadsbesparing, stakeholder alignment. Använd termer som RACI, process efficiency, decision points. Visa alltid "business impact" i dina förslag.',
    en: 'Focus on business value, KPIs, ROI, time/cost savings, stakeholder alignment. Use terms like RACI, process efficiency, decision points. Always show "business impact" in your suggestions.',
  },
  other: {
    sv: 'Håll neutral, professionell ton utan specifik domänvokabulär. Förklara begrepp när de förekommer.',
    en: 'Keep a neutral, professional tone without domain-specific vocabulary. Explain concepts when they appear.',
  },
};

export function buildRoleLayer(role: UserRole, lang: Language): string {
  return ROLE_LAYERS[role][lang] ?? ROLE_LAYERS[role].en;
}
